import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../css/style.css";
import "../css/purpleresponsive.css";
import Logoheader from "../image/theme/purplelogo.png";
import menu from "../image/theme/hamburger.png";
import { Link } from "react-router-dom";
import Login from "./login";
import Signup from "./signup";
import ForgotPassword from "./forgot-password";
import { apiCalling, forceLogout } from "../apiService";
import { authHelper } from "../utilis/authHelper";

export default class header extends Component {
  state = {
    showSignIn: false,
    showSignUp: false,
    showForgot: false,
    showPatientMenu: false,
    showDoctorMenu: false,
    menuOpen: false,
    isLogin: window.sessionStorage.getItem("isLogin") === "true",
    role: authHelper.getRole(),
  };

  componentDidMount() {
    if (this.state.role === "ROLE_DOCTOR") {
      this.setState({ showDoctorMenu: true });
    }
    if (this.state.role === "ROLE_USER") {
      this.setState({ showPatientMenu: true });
    }
  }

  handleLogout = () => {
    const logoutReq = {
      method: "POST",
      body: JSON.stringify({
        functionName: "logout",
        siteId: window.sessionStorage.getItem("siteId"),
        userId: authHelper.getUserId(),
      }),
    };

    apiCalling(logoutReq).then((data) => {
      if (data.success == "1") {
        window.location.href = "/";
        sessionStorage.clear();
        alert(data.successMessage);
        authHelper.logout(true);
        forceLogout();
      } else {
        alert("Logout Failed");
      }
    });
  };

  render() {
    const {
      showSignIn,
      showSignUp,
      showForgot,
      showPatientMenu,
      showDoctorMenu,
      menuOpen,
      isLogin,
    } = this.state;

    return (
      <header>
        <span className="mobileToggle">
          <span></span>
        </span>
        <div className="container header">
          <div className="logo">
            <Link to="/">
              <img src={Logoheader} alt="logo"></img>
            </Link>
          </div>
          <div className="menu">
            <span
              className="menuIcon"
              onClick={() => this.setState({ menuOpen: !menuOpen })}
            >
              <img src={menu} alt=""></img>
            </span>
            <ul className={`menu-ul ${menuOpen ? "open" : ""}`}>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/home/aboutus">About us</Link>
              </li>
              <li>
                <Link to="/home/doctor-list-main">Doctor List</Link>
              </li>
              <li>
                <Link className="imgshowhide">
                  Solutions
                  <i
                    class="fa fa-chevron-down ml-1"
                    style={{ fontSize: "10px" }}
                  ></i>
                </Link>
                <div className="subMenuMain arrow-up">
                  <div className="subMenuList">
                    <Link to="/home/branded-apps-website">
                      Branded Apps & Websites
                    </Link>
                  </div>
                  <div className="subMenuList">
                    <Link to="/home/telehealth">Telemedicine Technology</Link>
                  </div>
                  <div className="subMenuList">
                    <Link to="/home/clinic-management">
                      Practice Management Solutions
                    </Link>
                  </div>
                </div>
              </li>
              <li>
                <Link to="/home/clients">Clients</Link>
              </li>
              <li>
                <Link to="/home/contactus">Contact us</Link>
              </li>

              {showPatientMenu && (
                <li className="layoutPatientMenuTop menu-role">
                  <Link className="imgshowhide menu-role-link">
                    Hi Patient
                    <i
                      class="fa fa-chevron-down ml-1"
                      style={{ fontSize: "10px" }}
                    ></i>
                  </Link>
                  <div className="subMenuMain arrow-up">
                    <div className="subMenuList">
                      <Link to="/patient/profile"> My Profile</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/patient/inbox"> Inbox</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/patient/videocalllist">
                        Video/Audio Appointments
                      </Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/chatmessagegroup"> Chat</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/patient/appointmentlist"> Appointments</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/patient/healthrecordlogin">
                        Health Records
                      </Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/patient/history"> History</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="#" onClick={this.handleLogout}>
                        Sign Out
                      </Link>
                    </div>
                  </div>
                </li>
              )}

              {showDoctorMenu && (
                <li className="layoutDoctorMenuTop menu-role">
                  <Link className="imgshowhide menu-role-link">
                    Hi Doctor
                    <i
                      class="fa fa-chevron-down ml-1"
                      style={{ fontSize: "10px" }}
                    ></i>
                  </Link>
                  <div className="subMenuMain arrow-up">
                    <div className="subMenuList">
                      <Link to="/doctor/doctorprofile"> Profile</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/doctor/dashboard"> My Dashboard</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="/doctor/doctorinbox"> Inbox</Link>
                    </div>
                    <div className="subMenuList">
                      <Link to="#" onClick={this.handleLogout}>
                        Sign Out
                      </Link>
                    </div>
                  </div>
                </li>
              )}

              {!isLogin && (
                <li>
                  <span
                    className="commonButton"
                    id="loginMenu"
                    onClick={() =>
                      this.setState({
                        showSignIn: !showSignIn,
                        showSignUp: false,
                        showForgot: false,
                      })
                    }
                  >
                    Login
                  </span>
                  {showSignIn && <Login />}
                  {showSignUp && <Signup />}
                  {showForgot && <ForgotPassword />}
                </li>
              )}
            </ul>
          </div>
        </div>
      </header>
    );
  }
}
